// Lib
import React from 'react';
import { flowRight } from 'lodash';

// Decorators
import notificationsFetchDecorator from '../../workspace/header/workspaceToolsHeader/notifications/notificationsFetchDecorator';
import notificationsObservedDecorator from '../../workspace/header/workspaceToolsHeader/notifications/notificationsObservedDecorator';
import markSeenNotificationsDecorator from '../../workspace/header/workspaceToolsHeader/notifications/markSeenNotificationsDecorator';

const MobileNotificationsReconciler: React.FC = () => null;

const enhance = flowRight(notificationsFetchDecorator, notificationsObservedDecorator, markSeenNotificationsDecorator);

/**
 * The entire purpose of this component is to ensure that notifications are
 * fetched if the app is backgrounded then later foregrounded, and marking
 * notifications as seen and observed.
 *
 * It uses the same decorators that are used on the desktop app to achieve this.
 *
 * NOTE: The decorator pattern is old, however converting some of them are not trivial,
 * so it's safer to leave them as is for now, unless more time will be spent
 * regression testing them.
 */
export default enhance(MobileNotificationsReconciler);
